/**
 * WORLD-CUP-MOBILE-UX-FINAL-P0 — Live Match Mode signal.
 *
 * A lightweight global flag any component can flip while a match is LIVE
 * to suppress secondary cards / promos / discovery surfaces and let
 * marker + prediction + audio sync + share dominate the screen.
 */
import { useSyncExternalStore } from "react";
import { trackEvent } from "@/lib/audit";

let active = false;
let version = 0;
const listeners = new Set<() => void>();
function emit() {
  version += 1;
  listeners.forEach((l) => l());
}

export function setLiveMatchMode(next: boolean) {
  if (active === next) return;
  active = next;
  void trackEvent("mobile_live_match_mode_changed", { active });
  emit();
}

export function isLiveMatchMode() {
  return active;
}

const subscribe = (fn: () => void) => {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
};
const getSnap = () => version;

export function useLiveMatchMode(): boolean {
  useSyncExternalStore(subscribe, getSnap, getSnap);
  return active;
}